import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestRespinAction } from 'automaton/actions/RequestRespinAction'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { getFreespinsWinState } from 'automaton/states/FreespinsWinState'

export function getFreespinsRespinState() {
  const winModel = game.models.WinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const spinModel = game.models.SpinModel.get()

  const name = 'RESPIN'
  const actions = [
    getRequestRespinAction(),
    getReelSpinAction(),
  ]
  const transition = () => winModel.winLines.length
    ? getFreespinsWinState()
    : spinModel.respin.length
      ? getFreespinsRespinState()
      : freespinModel.left
        ? getFreespinsSpinState()
        : getFreespinEndState()

  return {
    name,
    actions,
    transition,
  }
}
